import { motion } from 'framer-motion';

import { CreateMediaKitButton } from '../CustomShareablesListing/components/CreateMediaKitButton';
import { MediaKitsCard } from './MediaKitsCard';

interface MediaKitsLandingProps {
  onCreateClick: () => void;
  isCreating: boolean;
}

const popUpVariant = {
  hidden: { opacity: 0, y: 30, scale: 0.95 },
  visible: { opacity: 1, y: 0, scale: 1 },
};

export const MediaKitsLanding = ({
  onCreateClick,
  isCreating,
}: MediaKitsLandingProps) => {
  return (
    <div className="flex min-h-screen items-start justify-center px-4 pt-10">
      <div className="flex w-full flex-col gap-10">
        <motion.div
          className="text-center"
          initial="hidden"
          animate="visible"
          transition={{ duration: 0.7, ease: 'easeOut' }}
          variants={popUpVariant}
        >
          <h1 className="text-32 font-500 text-neutral-800">
            What is a Media Kit?
          </h1>

          <p className="text-16 font-400 text-neutral-800">
            Foam Media Kits are a live, all-in-one landing page that allow you
            to easily showcase your content, metrics, and experience to brands.
          </p>

          <CreateMediaKitButton
            onClick={onCreateClick}
            isDisabled={isCreating}
            className="mt-6"
            trackId="create-media-kit-btn-unmanaged-creators"
            hideIcon
          />
        </motion.div>

        <motion.div
          initial="hidden"
          animate="visible"
          transition={{ duration: 0.7, ease: 'easeOut', delay: 0.1 }}
          variants={popUpVariant}
        >
          <MediaKitsCard />
        </motion.div>
      </div>
    </div>
  );
};
